import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Tabela, UnidataTable } from '~/components';
import { MODULO_CTF, CUSTOMIZACAO_RAIZEN } from '~/constants/modules';
import { t, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  empresasveiculosInRequest,
  findEmpresasVeiculo,
  deleteEmpresasVeiculo,
  recordFiltering,
} from '~/store/modules/empresaveiculo/actions';

import Tabs from './tabs';

function EmpresaVeiculoList() {
  const redux = useSelector((state) => state.empresaveiculo);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const formaidStatus = useMemo(
    () => [
      { label: 0, value: 'Não solicita motorista' },
      { label: 1, value: 'Solicita motorista' },
      // { label: 2, value: 'Solicita motorista e senha' },
    ],
    []
  );

  const header = useMemo(() => {
    const data = [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'statusempresaveiculo',
        label: t('s.cadastro.empresaveiculo.statusempresaveiculo'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ];

    if (!can(CUSTOMIZACAO_RAIZEN)) {
      data.splice(1, 0, {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: {
          type: 'text',
        },
      });
    }

    if (can(CUSTOMIZACAO_RAIZEN)) {
      data.splice(1, 0, {
        id: 'exibemotoristaempresaveiculo',
        label: t('s.cadastro.empresaveiculo.exibemotoristaempresaveiculo'),
        formatted: (value) =>
          formaidStatus.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: formaidStatus },
      });
    }

    return data;
  }, []);

  // const header = useMemo(
  //   () => [
  //     {
  //       id: 'idempresaveiculo',
  //       label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
  //       filter: {
  //         type: 'text',
  //       },
  //     },
  //     {
  //       id: 'nomeempresaveiculo',
  //       label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
  //       filter: {
  //         type: 'text',
  //       },
  //     },
  //     {
  //       id: 'statusempresaveiculo',
  //       label: t('s.cadastro.empresaveiculo.statusempresaveiculo'),
  //       formatted: (value) => status.find((s) => s.label === value).value || '',
  //       filter: { type: 'select', options: status },
  //     },
  //   ],
  //   [status]
  // );

  const fieldlist = [
    'idempresaveiculo',
    'nomeempresaveiculo',
    'statusempresaveiculo',
  ];

  const substituirHeader = {
    idempresaveiculo: t('s.cadastro.empresaveiculo.idempresaveiculo'),
    nomeempresaveiculo: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
    statusempresaveiculo: t('s.cadastro.empresaveiculo.statusempresaveiculo'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findEmpresasVeiculo}
      remove={deleteEmpresasVeiculo}
      form={Tabs}
      keys="idempresaveiculo"
      detach="idempresaveiculo"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'empresasveiculos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Empresas e Veiculos',
          substituirValores: {
            statusempresaveiculo: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default EmpresaVeiculoList;
